module.exports = __webpack_public_path__ + "static/media/luna.9304c6fe.jpeg";